import { css } from '@emotion/react'
import { Button, Heading, HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { PageContainer } from 'components/layout/PageContainer'
import { ReactComponent as AvisoCidadaoCdsIcon } from 'images/cidadao/aviso-cidadao-cds.svg'
import { useHistory } from 'react-router'

export function AlertNovidadesCidadao() {
  const theme = useTheme()
  const history = useHistory()
  const styles = createStyles(theme)

  return (
    <PageContainer>
      <HFlow justifyContent='center'>
        <HFlow hSpacing={1} alignItems='center' justifyContent='center' style={styles.container}>
          <AvisoCidadaoCdsIcon css={styles.img} />
          <VFlow>
            <VFlow vSpacing={0.2} style={styles.text}>
              <Heading level={3}>O Cadastro Individual evoluiu</Heading>
              <Text>
                O antigo módulo do cidadão mudou e agora se chama Cadastro Individual, passando a centralizar a gestão
                dos cadastros e eliminando a necessidade de usar o CDS. Esse novo módulo também funciona de forma
                conectada ao Acompanhamento do Território, de modo que atualizações feitas nele refletem na formação da
                família e na vinculação ao território.
              </Text>
            </VFlow>
            <Button onClick={() => history.push('/cidadao')} skin='outline' kind='primary' size='small'>
              Acessar novo módulo
            </Button>
          </VFlow>
        </HFlow>
      </HFlow>
    </PageContainer>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    margin-top: 2rem;
    margin-bottom: 0.5rem;
    padding: 0.75rem 1.5rem;
    outline: 1px solid ${theme.pallete.gray.c60};
    background-color: ${theme.pallete.surface.main};
    max-width: 60rem;
    border-radius: 0.4rem;
    min-height: 150px;
  `,
  text: css`
    max-width: 55rem;
  `,
  img: css`
    align-self: flex-end;
    margin-bottom: -0.75rem;
  `,
})
